var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.3477C10.7 12.3477 11.2 11.6477 12 10.8477C13 9.94766 13.5 8.64766 13.5 7.34766C13.5 5.75636 12.8679 4.23023 11.7426 3.10502C10.6174 1.9798 9.0913 1.34766 7.5 1.34766C5.9087 1.34766 4.38258 1.9798 3.25736 3.10502C2.13214 4.23023 1.5 5.75636 1.5 7.34766C1.5 8.34766 1.7 9.54766 3 10.8477C3.7 11.5477 4.3 12.3477 4.5 13.3477M4.5 17.3477H10.5M5.5 21.3477H9.5",
    stroke: "#43B5F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightbulb);
export default __webpack_public_path__ + "static/media/icon_lightbulb.d17a07e16816f6575bb8ab70081d1e0d.svg";
export { ForwardRef as ReactComponent };